<script lang="ts" setup>
import { $fetch } from '@/home/plugins/fetch';
import { CONTRIBUTOR_CATEGORY_SUB_PLATINUM } from '@/home/utils/constants';
import { useAsyncData } from '@/home/hooks/async-data';

const { data: contributors } = useAsyncData('home:contributors', () => $fetch('/donor/v1/show', { data: { sc: CONTRIBUTOR_CATEGORY_SUB_PLATINUM, limit: -1 } }))
</script>

<template>
  <section class="page-home-contributors">
    <div class="mx-auto max-w-1200 pb-160 pt-100">
      <div class="flex items-center justify-between">
        <h2 class="relative m-0 text-40 text-#292D33 font-500 leading-64">
          {{ $t('home.contributors.platinumDonor') }}
        </h2>
        <RouterLink to="/cooperation/partner" class="flex-y-center flex-shrink-0 gap-x-16 text-16 text-#1281FF font-500 no-underline">
          <span>{{ $t('home.contributors.more') }}</span>
          <span class="i-home-icons:arrow-right-2 block size-24"></span>
        </RouterLink>
      </div>

      <ul class="mb-0 mt-56 flex flex-shrink-0 flex-wrap list-none gap-32 p-0">
        <li class="h-78 w-213" v-for="item in contributors" :key="item.donorId">
          <img :data-src="item.logo" class="lazyload block size-full rounded-8 object-contain" :alt="item.donorName" :title="item.donorName">
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
